export default {
  QUOTES_RELATED_SNAPSHOT: "QUOTES_RELATED_SNAPSHOT",
  INITIAL_ASN_RELATED_SNAPSHOT: "INITIAL_ASN_RELATED_SNAPSHOT"
}



// WEBPACK FOOTER //
// ./src/pages/asns/constants/index.js